export interface StringLookup {
  id: string | number;
  description: string;
}
